import React, {useEffect} from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import {useImmerReducer} from 'use-immer'
import {auth, firestore} from './firebase'

import StateContext from './StateContext'
import DispatchContext from './DispatchContext'
import FlashMessages from './components/FlashMessages/FlashMessages'

import "./index.css";
import Home from './components/Home/Home'
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'

// WP CORE
import SinglePost from './components/Blog/SinglePost'

// MEDIA
import AddMedia from './components/Media/AddMedia'

import SinglePage from './components/Pages/SinglePage'

// Add post / recipe /post type
import CreatePost from './components/Post/CreatePost'
import EditPost from './components/Post/EditPost'

// RECIPES
import RecipeCategories from './components/Recipe/RecipeCategories'
import RecipeCategory from './components/Recipe/RecipeCategory'

// Buddypress
import Members from './components/BuddyPress/Member/Members';

// Custom components
import View from './components/View/View'
import ViewJarallax from "./components/View/ViewJarallax";

import DiscoverPage from "./components/Search/DiscoverPage";
import AuthPage from "./pages/AuthPage";
import ProfilePage from "./pages/ProfilePage";
import PostsPage from "./pages/PostsPage";
import EditProfilePage from "./pages/EditProfilePage";

function App() {

    const camillahardilla = "https://camillahardilla.com/"

    // Min kokebok details
    const minKokebok = {
        title: "My Recipes",
        image: "https://camillahardilla.com/wp-content/uploads/2020/07/white-and-brown-cooked-dish-on-white-ceramic-bowls-958545.jpg",
        header: {
            
        }
    }

    const initialState = {
        loggedIn: false,
        userId: "",
        userData: {
            profile_image: "",
            name: "",
            authorId: ""
        },
        flashMessages: [],
        isSearchOpen: false,
        darkBackground: false,
        wordpressUrl: camillahardilla + "wp-json/wp/v2/",
        wordpressBaseUrl: camillahardilla,
        wordpressSite: "min-kokebok",
        currentPage: "home"
    }

    function ourReducer(draft, action) {
        switch (action.type) {
            case "login":
                draft.loggedIn = true
                draft.userId = action.value
                return
            case "userName":
                draft.userData.name = action.value
                return
            case "userAvatar":
                draft.userData.profile_image = action.value 
                return
            case "userAuthorId":
                draft.userData.authorId = action.value 
                return
            case "logout":
                draft.loggedIn = false
                return
            case "flashMessage":
                draft.flashMessages.push(action.value)
                return 
            case "currentPage":
                draft.currentPage = action.value
                return
            case "openSearch":
                draft.isSearchOpen = true
                return
            case "closeSearch":
                draft.isSearchOpen = false
                return            
            case "openModal":
                draft.darkBackground = true
                return
            case "closeModal":
                draft.darkBackground = false
                return
        }
    }
    const [state, dispatch] = useImmerReducer(ourReducer, initialState);

    useEffect(() => {

        auth.onAuthStateChanged((user) => {
            if (user) {
                console.log(user.uid, "USER ID FETCHED")
                dispatch({type: "login", value: user.uid});
            } 
            
        })

    }, [])

    useEffect(() => {

        if (state.loggedIn && state.userId) {

            try {
                const authorRef = firestore.collection("authors");
                authorRef.where("user_id", "==", state.userId).onSnapshot(({docs}) => {
                    const author = docs.map(doc => {
                        return {id: doc.id, ...doc.data()}
                    })
                    if (author.length) {
                        //console.log(author[0], "author App.js")
                        localStorage.setItem("myRecipesUserAvatar", author[0].profile_image)
                        localStorage.setItem("myRecipesUserName", author[0].name)
                        localStorage.setItem("myRecipesAuthorId", author[0].id)
                        dispatch({type: "userAvatar", value: author[0].profile_image})
                        dispatch({type: "userName", value: author[0].name})
                        dispatch({type: "userAuthorId", value: author[0].id})
                    }

                })
            } catch (error) {
                
            }

        }

    }, [state.loggedIn, state.userId])

    return (
      <StateContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>
      <BrowserRouter>
      <FlashMessages messages={state.flashMessages} />
        <Header />
          <Switch>

            <Route path="/" exact>
              <>
                <ViewJarallax image={minKokebok.image} preText="Welcome to " text={minKokebok.title} />
                <Home/>
              </>
            </Route>

            <Route path="/innlegg/:page" exact>
              <PostsPage />
            </Route>

            <Route path="/innlegg/single/:id" exact>
              <SinglePost/>
            </Route>

            <Route path="/discover" exact>
                <DiscoverPage />
            </Route>

            <Route path="/sider/single/:id" exact>
                <SinglePage />
            </Route>

            <Route path="/login" exact>
                <AuthPage />
            </Route>

            <Route path="/create-post" exact>
                <CreatePost/>
            </Route>

            <Route path="/edit-post/:id">
                <EditPost/>
            </Route>

            <Route path="/add-media" exact>
                <AddMedia />
            </Route>

            <Route path="/authors" exact>
                <Members />
            </Route>

            <Route path="/member/:id" exact>
                <ProfilePage />
            </Route>

            <Route path="/member/edit/:id" exact>
                <EditProfilePage />
            </Route>

            <Route path="/categories" exact>
                <>
                    <View text="Courses" image="https://camillahardilla.com/wp-content/uploads/2020/02/flat-lay-photography-of-vegetable-salad-on-plate-1640777-scaled.jpg" />
                    <RecipeCategories />
                </>
            </Route>
            <Route path="/category/:id" exact>
                <RecipeCategory />
            </Route>
            

          </Switch>
          <Footer />
      </BrowserRouter>
      </DispatchContext.Provider>
      </StateContext.Provider>
    );

}

export default App;
